import { render, staticRenderFns } from "./CountrySupportOverview.vue?vue&type=template&id=61096899"
import script from "./CountrySupportOverview.vue?vue&type=script&lang=js"
export * from "./CountrySupportOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports